module.exports = __webpack_public_path__ + "img/logo2-negative.3975149f.svg";